import { render, staticRenderFns } from "./today_arrive.vue?vue&type=template&id=18ab8f1c&"
import script from "./today_arrive.vue?vue&type=script&lang=js&"
export * from "./today_arrive.vue?vue&type=script&lang=js&"
import style0 from "./today_arrive.vue?vue&type=style&index=0&id=18ab8f1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports